import { siteConfig, heroBadges } from '@/mocks/data';

export default function HeroSection() {
  const whatsappHref = `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent('Merhaba, Atak Sistem Enerji Fineco Isı Pompası hakkında bilgi almak istiyorum.')}`;

  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Modern%20luxury%20villa%20exterior%20with%20dark%20anthracite%20gray%20heat%20pump%20outdoor%20unit%20mounted%20elegantly%20on%20wall%2C%20premium%20residential%20architecture%2C%20clean%20landscaping%2C%20professional%20architectural%20photography%2C%20warm%20golden%20hour%20lighting%2C%20energy%20efficiency%20concept%2C%20modern%20minimalist%20design%2C%20high%20quality%20detail&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="Fineco Isı Pompası - Modern Villa Isıtma ve Soğutma"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-4 md:px-6 py-16 md:py-20">
        <div className="flex flex-col items-center text-center">
          <div className="inline-flex items-center gap-2 bg-accent-500/90 text-background-50 px-4 py-1.5 rounded-full text-xs font-medium mb-6 whitespace-nowrap">
            <i className="ri-verified-badge-line w-3.5 h-3.5 flex items-center justify-center"></i>
            Fineco Isı Pompaları Yetkili Bayisi
          </div>

          <h1 className="font-heading text-3xl sm:text-4xl md:text-5xl lg:text-6xl text-background-50 max-w-4xl leading-tight mb-5">
            Fineco Isı Pompaları ile<br className="hidden sm:block" /> 4 Mevsim Konfor
          </h1>

          <p className="text-background-50/80 text-sm md:text-base max-w-2xl mb-8 leading-relaxed">
            Atak Sistem Enerji güvencesiyle rezistans takviyesiz, yüksek verimli, modern ısıtma ve soğutma çözümleri.
          </p>

          <div className="flex flex-wrap justify-center gap-2 mb-8 max-w-3xl">
            {heroBadges.map((badge, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1 bg-background-50/15 backdrop-blur-sm text-background-50 px-3 py-1.5 rounded-full text-xs font-medium border border-background-50/20 whitespace-nowrap"
              >
                <i className="ri-check-line text-primary-400 w-3 h-3 flex items-center justify-center"></i>
                {badge}
              </span>
            ))}
          </div>

          <div className="flex flex-col sm:flex-row items-center gap-3">
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white px-6 py-3 rounded-md text-sm font-semibold hover:bg-[#1faa51] transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
            >
              <i className="ri-whatsapp-line w-5 h-5 flex items-center justify-center"></i>
              WhatsApp'tan Bilgi Al
            </a>
            <a
              href={whatsappHref}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-background-50 text-foreground-900 px-6 py-3 rounded-md text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap w-full sm:w-auto justify-center"
            >
              <i className="ri-search-eye-line w-5 h-5 flex items-center justify-center"></i>
              Size Uygun Sistemi Öğrenin
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}